import React from 'react';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { FormExtraOptions } from '../../../../../molecules/formExtraOptions';
import { useJobTitleFilter } from './useJobTitleFilter';
import { FormikJobTitleMultiSelect } from './FormikJobTitleMultiSelect';

export const JobTitleFilter = ({ value, setFilters, sharedList, orderBy, jobTitlesIncluded }) => {
  const { formSchema, onSubmit, jobTitleIncludedOptions } = useJobTitleFilter({
    sharedList,
    orderBy,
    setFilters,
  });

  return (
    <Formik
      initialValues={{ jobTitles: value || [], jobTitlesIncluded: jobTitlesIncluded || jobTitleIncludedOptions[0] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <FormikJobTitleMultiSelect name="jobTitles" sharedList={sharedList} orderBy={orderBy} />
        <Field
          name="jobTitlesIncluded"
          placeholder="Current"
          component={FormExtraOptions}
          options={jobTitleIncludedOptions}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

JobTitleFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
  sharedList: PropTypes.object,
  orderBy: PropTypes.oneOf(['count', 'alpha']),
  jobTitlesIncluded: PropTypes.object,
};

JobTitleFilter.defaultProps = {
  value: [],
  sharedList: null,
  orderBy: 'count',
  jobTitlesIncluded: null,
};
